import { ResourceType, Provider } from '@repo/api-gw-sdk';

export const GoogleWorkspaceResourceType = ResourceType.GoogleWorkspaceResource;

interface ResourceTypeInfo {
  displayName: string;
  provider: Provider;
}

const resourceTypes: Record<ResourceType, ResourceTypeInfo> = {
  // GCP
  [ResourceType.GcpCloudSqlInstance]: {
    displayName: 'Cloud SQL',
    provider: Provider.Gcp,
  },
  [ResourceType.GcpComputeEngineInstance]: {
    displayName: 'GCE Instance',
    provider: Provider.Gcp,
  },
  [ResourceType.GcpBigQuery]: {
    displayName: 'BigQuery',
    provider: Provider.Gcp,
  },
  [ResourceType.GcpCloudStorageBucket]: {
    displayName: 'GCS Bucket',
    provider: Provider.Gcp,
  },
  [ResourceType.GcpCloudFirestore]: {
    displayName: 'FirestoreDB',
    provider: Provider.Gcp,
  },
  [ResourceType.GcpGkeNamespace]: {
    displayName: 'GKE Namespace',
    provider: Provider.Gcp,
  },
  [ResourceType.GcpDisk]: {
    displayName: 'GCE Disk',
    provider: Provider.Gcp,
  },
  [ResourceType.GcpSapHanaVm]: {
    displayName: 'SAP Hana Instance',
    provider: Provider.Gcp,
  },

  // AWS
  [ResourceType.AwsEc2]: {
    displayName: 'EC2',
    provider: Provider.Aws,
  },
  [ResourceType.AwsEfs]: {
    displayName: 'EFS',
    provider: Provider.Aws,
  },
  [ResourceType.AwsFsx]: {
    displayName: 'FSx',
    provider: Provider.Aws,
  },
  [ResourceType.AwsRds]: {
    displayName: 'RDS',
    provider: Provider.Aws,
  },
  [ResourceType.AwsS3]: {
    displayName: 'S3',
    provider: Provider.Aws,
  },
  [ResourceType.AwsDynamoDb]: {
    displayName: 'DynamoDB',
    provider: Provider.Aws,
  },
  [ResourceType.AwsEksNamespace]: {
    displayName: 'EKS Namespace',
    provider: Provider.Aws,
  },
  [ResourceType.AwsEbsVolume]: {
    displayName: 'EBS Volume',
    provider: Provider.Aws,
  },
  [ResourceType.AwsKeyspacesTable]: {
    displayName: 'Keyspaces Table',
    provider: Provider.Aws,
  },
  [ResourceType.AwsRedshift]: {
    displayName: 'Redshift',
    provider: Provider.Aws,
  },
  [ResourceType.AwsDocumentdb]: {
    displayName: 'DocumentDB',
    provider: Provider.Aws,
  },
  [ResourceType.AwsNeptune]: {
    displayName: 'Neptune',
    provider: Provider.Aws,
  },

  // ATLAS
  [ResourceType.AtlasMongodbCluster]: {
    displayName: 'Atlas Cluster',
    provider: Provider.MongoAtlas,
  },

  // AZURE
  [ResourceType.AzureStorageAccount]: {
    displayName: 'Storage Account',
    provider: Provider.Azure,
  },
  [ResourceType.AzureDisk]: {
    displayName: 'Disk',
    provider: Provider.Azure,
  },
  [ResourceType.AzureVirtualMachine]: {
    displayName: 'Virtual Machine',
    provider: Provider.Azure,
  },
  [ResourceType.AzureSqlVirtualMachine]: {
    displayName: 'SQL Virtual Machine',
    provider: Provider.Azure,
  },
  [ResourceType.AzureFileShare]: {
    displayName: 'File Share',
    provider: Provider.Azure,
  },
  [ResourceType.AzureSqlDatabase]: {
    displayName: 'SQL Database',
    provider: Provider.Azure,
  },
  [ResourceType.AzureSqlManagedInstance]: {
    displayName: 'SQL Managed Instance',
    provider: Provider.Azure,
  },
  [ResourceType.AzureSapHanaVm]: {
    displayName: 'SAP Hana Instance',
    provider: Provider.Azure,
  },
  [ResourceType.AzureMysql]: {
    displayName: 'MySQL Flexible Server',
    provider: Provider.Azure,
  },
  [ResourceType.AzurePostgresql]: {
    displayName: 'PostgreSQL Flexible Server',
    provider: Provider.Azure,
  },
  [ResourceType.AzureCosmosdbMongodb]: {
    displayName: 'Cosmos DB for MongoDB',
    provider: Provider.Azure,
  },
  [ResourceType.AzureCosmosdbNosql]: {
    displayName: 'Cosmos DB for NoSql',
    provider: Provider.Azure,
  },
  [ResourceType.AzureAksNamespace]: {
    displayName: 'AKS Namespace',
    provider: Provider.Azure,
  },

  // GOOGLE WORKSPACE
  [ResourceType.GoogleWorkspaceResource]: {
    displayName: 'Google Workspace',
    provider: Provider.GoogleWorkspace,
  },

  // UNSPECIFIED
  [ResourceType.ResourceTypeUnspecified]: {
    displayName: '',
    provider: Provider.ProviderUnspecified,
  },
};

export const ResourceTypes: Record<string, ResourceTypeInfo> = {
  ...Object.fromEntries(Object.entries(resourceTypes)),
};
